import {JsonProperty} from '@hyperloris/tyson';

export class Mail {
  @JsonProperty()
  mail: string | undefined;
}
